module.exports = __webpack_public_path__ + "img/logo.c8999c02.png";